import { TableBody } from "react-aria-components";

import { EmptyTable } from "@/ui2/molecules/(table)/EmptyTable";
import { Table2 } from "@/ui2/atoms/(table)/Table";

import type { AdaptedCseRow } from "../helpers/adapters";

import { CseTableHeader } from "./components/CseTableHeader";
import { CseTableRow } from "./components/CseTableRow";
import { CseTableSkeleton } from "./components/CseTableSkeleton";

type CseTableProps = {
  isLoading: boolean;
  rows: AdaptedCseRow[];
};

export function CseTable({ isLoading, rows }: CseTableProps) {
  return (
    <Table2 aria-label="Customer success executives">
      <CseTableHeader />

      {isLoading ? (
        <CseTableSkeleton />
      ) : (
        <TableBody
          items={rows}
          renderEmptyState={() => <EmptyTable message="No customer success executives found" />}
        >
          {(row) => <CseTableRow row={row} />}
        </TableBody>
      )}
    </Table2>
  );
}
